import PopoverPosition from '@intercom/embercom-composer/components/mixins/popover-position';
import $ from 'jquery';
import Em from 'ember';
export default Em.Component.extend(PopoverPosition, {
  attributeBindings: ['style'],
  classNames: ['ic-popup', 'ic-popup-above', 'info-tooltip', 'is-light-theme', 'pseudonym-warning-tooltip'],
  isVisible: false,
  isWithinViewport: true,
  arrowHeight: 10,
  hasPositionOffset: true,
  regex: Em.computed('pseudonym', function () {
    let pseudonym = this.get('pseudonym');
    if (pseudonym && pseudonym.length > 5) {
      // arbitrary length sanity check to prevent composer from exploding if someone passes in a pseudonym of `a`
      return new RegExp(`(${pseudonym})`, 'gi');
    }
    return false;
  }),
  didInsertElement() {
    this._super(...arguments);
    this.setupEditorDimensions();
    if (this.get('editor')) {
      this.addEventHandler();
    } else {
      this.addObserver('editor', this, this.removeObserverAndAddEventHandler);
    }
  },
  removeObserverAndAddEventHandler() {
    this.removeObserver('editor', this, this.removeObserverAndAddEventHandler);
    this.addEventHandler();
  },
  addEventHandler() {
    this.get('editor').on('render', this, this.insertWarnings);
    this.get('editor').on('syncWithoutRender', this, this.lookForMatches);
  },
  willDestroyElement() {
    this._super(...arguments);
    this.get('editor').off('render', this, this.insertWarnings);
    this.get('editor').off('syncWithoutRender', this, this.lookForMatches);
  },
  insertWarnings() {
    let $editor = this.get('editor.$editor');
    let regex = this.get('regex');
    if (regex) {
      /* @pat - We need to disable sanitization as DOMPurify will strip the <ic-marker> which makes this work */
      /* eslint-disable-next-line jquery-unsafe/no-html */
      $editor.html(function (_, html) {
        return html.replace(regex, '<span class="pseudonym-warning">$1</span>');
      });
      $editor.find('span.pseudonym-warning').hover(this.showTooltip.bind(this), this.hideTooltip.bind(this));
    }
  },
  lookForMatches() {
    let editor = this.get('editor');
    let $editor = this.get('editor.$editor');
    let regex = this.get('regex');
    if (regex && !$editor.find('.pseudonym-warning').length && $editor.html().match(regex)) {
      editor.updateDomAndSelection();
    }
  },
  showTooltip(e) {
    let $target = $(e.currentTarget);
    let targetPosition = $target.position();
    let targetWidth = $target.outerWidth();
    this.set('selectionCoordinates', {
      top: targetPosition.top,
      left: targetPosition.left,
      width: targetWidth
    });
    this.set('isVisible', true);
  },
  hideTooltip() {
    this.set('isVisible', false);
  }
});